import React from 'react';
import { message, Modal } from 'antd';
import { ClockCircleOutlined, WechatOutlined } from '@ant-design/icons';
import { createWXPayQRCode } from '../pages/wechat';
import CopyToClipboard from './copyToClipboard';

export default ({orderNo, orderUrl, accId, shopId, amount: shouldAmount = 0, realAmount = 0, pays = [{ amount: 0 }], onFlowChange: onChange = () => {}}, Info = null) => {
    if(!orderNo || !accId) return false;

    // 根据pays计算真实支付
    const realPayAmount = pays.reduce((total, pay) => {
        total += pay.amount;
        return total;
    }, 0);

    let tRealAmount = (realAmount - realPayAmount)/100;
        tRealAmount = tRealAmount < 0 ? 0 : tRealAmount;

    if(tRealAmount <= 0) return message.warning('无需再收款！或修改应收金额？');

    Modal.confirm({
        title: '输入收款金额',
        icon: null,
        content: <div>
            {Info}
            <div style={{padding: '20px 0', textAlign: 'center'}}>
                {/* <input type='number' autoFocus id="amountInput" min={1} defaultValue={shouldAmount} style={{padding: '10px 5px', width: '100%'}} /> */}
                收款金额<b style={{color: 'red', fontSize: '20px'}}> {tRealAmount} </b>元
                {orderUrl && <p><span style={{color: 'green'}}>{orderUrl}</span>&nbsp;<CopyToClipboard text={orderUrl} node={<a>复制支付链接</a>} /></p>}
            </div>
        </div>,
        okText: '确认展示收款码',
        cancelText: '返回修改金额',
        onOk: async () => {
            let content = null;
            let okText = '确定';

            if(tRealAmount > 0) {
                okText = '已支付';
                let url = await createWXPayQRCode({orderNo, accId, amount: tRealAmount, shopId});
                content = <div style={{ textAlign: 'center', marginLeft: '-34px' }}>
                    <div>扫码支付金额<span style={{color: 'green'}}>{tRealAmount}</span>元</div>
                    <img src={url.imageUrl} width={200} alt="" />
                </div>;
            }else{
                okText = '确定';
                content = <div style={{ textAlign: 'center', marginLeft: '-34px' }}>确定支付金额<span style={{color: 'red'}}>{tRealAmount}</span>元？</div>;
            }

            Modal.confirm({
                title: '微信支付',
                icon: <WechatOutlined />,
                content,
                // content: <div style={{ textAlign: 'center' }}>======</div>,
                okText,
                cancelText: '关闭',
                onOk: async () => {
                    // if(realAmount <= 0) {
                    //     let response = await fetch('/api/order-create-als', {
                    //         method: 'POST',
                    //         headers: {
                    //             'Content-Type': 'application/json'
                    //         },
                    //         body: JSON.stringify({
                    //             orderNo,
                    //             payStatus: 2,
                    //         })
                    //    });

                    //    let result = await response.json();

                    //    if(result.success) {
                    //         Modal.success({content: '支付成功！'});
                    //         onChange();
                    //    }else {
                    //         Modal.error(result.data);
                    //    }

                    //    return false;
                    // }
                    onChange();
                }
            })
        }
    });
}